var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61537 16C2.16794 16 1.78685 15.8427 1.4721 15.5279C1.15737 15.2132 1 14.8321 1 14.3847V2.00002H0V1.00002H4V0.230774H10V1.00002H14V2.00002H13V14.3847C13 14.8449 12.8458 15.2292 12.5375 15.5375C12.2292 15.8459 11.8449 16 11.3846 16H2.61537ZM12 2.00002H2V14.3847C2 14.5641 2.05769 14.7116 2.17308 14.827C2.28846 14.9423 2.43589 15 2.61537 15H11.3846C11.5385 15 11.6795 14.9359 11.8077 14.8077C11.9359 14.6795 12 14.5385 12 14.3847V2.00002ZM4.80768 13H5.8077V4.00002H4.80768V13ZM8.1923 13H9.19232V4.00002H8.1923V13Z",
    fill: "#A78721"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.28f483c3e39570934e12e812b9924aec.svg";
export { ForwardRef as ReactComponent };